/**
 * Number formatters ported verbatim from `dashboard.html:1417-1430`.
 *
 *   - `formatCurrency` → `$N.NN` (two fractional digits).
 *   - `formatNumber`   → locale-separated integer (`1,234,567`).
 *   - `formatPercent`  → `N.NN%`.
 *
 * All three return `-` when the input is null / undefined / NaN.
 * Parity rule: callers must NOT pre-guard nulls; pass the raw value
 * through so the "-" placeholder shows in tables.
 */

function isMissing(v: number | null | undefined): boolean {
  if (v === null || v === undefined) return true
  if (typeof v !== "number") return true
  return Number.isNaN(v)
}

export function formatCurrency(value: number | null | undefined): string {
  if (isMissing(value)) return "-"
  return "$" + Number(value).toFixed(2)
}

export function formatNumber(value: number | null | undefined): string {
  if (isMissing(value)) return "-"
  return Number(value).toLocaleString("en-US")
}

export function formatPercent(value: number | null | undefined): string {
  if (isMissing(value)) return "-"
  return Number(value).toFixed(2) + "%"
}
